import React, { Component } from "react";
import { connect } from "react-redux";
import { setCheckoutV2Step } from "../state/actions";

export class LegacyCheckoutRouteAdapter extends Component {
  componentDidMount() {
    const { history, location, step } = this.props;
    if (["profile", "/profile"].includes(location.state?.prevPath)) {
      history.replace(location.pathname.endsWith("/address") ? "/profile/addresses" : "/profile/details");
      return;
    }
    this.props.setStep(step);
    history.replace({
      pathname: "/checkout",
      search: location.search,
      hash: location.hash,
      state: {
        ...(location.state || {}),
        checkoutV2Step: step,
        legacyCheckoutPath: location.pathname,
      },
    });
  }

  render() {
    return null;
  }
}

export default connect(null, (dispatch) => ({
  setStep: (step) => dispatch(setCheckoutV2Step(step)),
}))(LegacyCheckoutRouteAdapter);
